import { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import AddBtns from "./AddBtns";
import TitleAndInput from "../common/TitleAndInput";
import Editor from "../editor/Editor";
import { gnbConst } from "../../constants/gnbConst";
import { BoxButtonTitle, CommonFooter, FlexColBetweenBox, InputLinkBox, InputTitle } from "../../style/common";
import { flexUnsetStart } from "../../style/mixins";
import { useAlertStore } from "../../store/alertStore";
// import { fileApiService } from "../../api/apiService";
// import { postFiles } from "../../api/files";
import { getContents, postContents, putContents } from "../../api/contents";
import { Spinner } from "../common/Spinner";
import { useNavigatePage } from "../../hooks/useNavigatePage";
import { useMemberStore } from "../../store/memberStore";

interface PostFile {
  data: {
    idx: string; // idx는 문자열 타입
  };
}

export default function Add() {
  const { idx } = useParams<{ idx: string }>();
  const { add } = useParams<{ add: string }>();
  const { memberPermitLevel } = useMemberStore();
  const pageTitle = gnbConst[2].title;
  const setAlert = useAlertStore((state) => state.setAlert);
  const { onMovementPage } = useNavigatePage();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  // const [file1, setFile1] = useState<File | null>(null);
  // const [file2, setFile2] = useState<File | null>(null);
  const [isSpinner, setIsSpinner] = useState(false);
  const userDataString = localStorage.getItem('member-storage');
  const userData = userDataString ? JSON.parse(userDataString) : null;

  useEffect(() => {
    if (gnbConst[0].level > memberPermitLevel) {
      alert("접근 권한이 없습니다.");
      onMovementPage(-1);
    }
  }, [memberPermitLevel]);

  // const handleFile1Change = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     setFile1(e.target.files[0]); // 첫 번째 파일 상태 업데이트
  //   }
  // };

  // const handleFile2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   if (e.target.files && e.target.files.length > 0) {
  //     setFile2(e.target.files[0]); // 두 번째 파일 상태 업데이트
  //   }
  // };

  const handleSubmit = async () => {
    try {
      if (title.trim() === "") {
        setAlert("제목을 입력해주세요.", "red");
        return;
      } else if (content === "") {
        setAlert("내용을 입력해주세요.", "red");
        return;
      }

      setIsSpinner(true);

      // 공지 저장
      const postNotice = async () => {
        // const contentFormHtml = `
        //   <!DOCTYPE html>
        //   <html lang="en">
        //   <head>
        //       <meta charset="UTF-8">
        //       <meta name="viewport" content="width=device-width, initial-scale=1.0">
        //   </head>
        //   <body>
        //     ${content}
        //   </body>
        //   </html>
        // `;
        const data = {
          title,
          content: content,
          is_html: 1,
          date_end: new Date("2200-12-31").toISOString(),
        };
        
        // if (postFileArr && postFileArr.length > 0) {
        //   postFileArr.map((obj: PostFile) => data["file_idx"] = [...data["file_idx"], obj.data.idx]);
        // }

        const responseFn = (responseData: ContentGetApiResponse) => {
          if (responseData.statusCode === 200) {
            setAlert("글 작성되었습니다.", "green");
            setIsSpinner(false);
            onMovementPage(-1);
          } else {
            setIsSpinner(false);
          }
        }
        
        if (idx && add) {
          const putData = {...data, idx: idx};
          const putContentsResponse = await putContents(putData, "notice");
          responseFn(putContentsResponse);
        } else {
          const postData = {...data, date_start: new Date().toISOString()};
          const postContentsResponse = await postContents(postData, "notice");
          responseFn(postContentsResponse);
        }
      };

      postNotice();
  
      // if (file1 || file2) {
      //   const appendFileConfig = (formData: FormData, file: File) => {
      //     formData.append("file[]", file, "[PROXY]");
      //     formData.append("file_path[]", "notice");
      //     formData.append("file_type[]", "1");
      //     formData.append("permit_level[]", "0");
      //   };
        
      //   const formDatas = new FormData();
    
      //   if (file1) appendFileConfig(formDatas, file1);
      //   if (file2) appendFileConfig(formDatas, file2);
  
      //   const filesResponse = await fileApiService.post<any>("/files/postMulti.php", formDatas);

      //   if (filesResponse.statusCode === 200) {
      //     const filesDataArr = filesResponse.data.files;
          
      //     const postFilesResponses: PostFildsResponse[] = await Promise.all(
      //       filesDataArr.map((filesData: PostFildsData) => postFiles(filesData))
      //     )
          
      //     if (postFilesResponses.every(e => e.statusCode === 200)) {
      //       postNotice();
      //     } else {
      //       setAlert("파일 업로드에 실패했습니다. 다시 시도해주세요.", "red");
      //       setIsSpinner(false);
      //       return;
      //     }
      //   } else {
      //     setAlert("글 작성되었습니다.", "red");
      //   }
      // } else {
      // postNotice();
      // }
    } catch (error) {}
  };

  useEffect(() => {
    if (add && idx) {
      const getNotice = async () => {
        try {
          const response = await getContents({ idx: idx }, "notice");
          if (response.statusCode === 200) {
            setTitle(response.data?.title ? response.data.title : "");
            setContent(response.data?.content ? response.data.content : "")
          } else {
            alert("공지사항을 불러오는데 실패했습니다.");
            onMovementPage(-1);
          }
        } catch (error) {}
      };

      getNotice();
    }
  }, [idx]);
  
  return (
    <FlexColBetweenBox>
      <div>
        <BoxButtonTitle>
          {pageTitle} - {idx ? "수정" : "등록"}
          <AddBtns onClick={handleSubmit} />
        </BoxButtonTitle>

        <AddBox>
          <InputLinkBox>
            <TitleAndInput
              title="제목"
              type="text"
              inputWidth="20rem"
              placeholder="제목을 입력해주세요."
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </InputLinkBox>

          <InputLinkBox>
            <TitleAndInput
              title="작성자"
              type="text"
              inputWidth="20rem"
              value={userData ? userData.state.memberName : "관리자"}
              disabled={true}
            />
          </InputLinkBox>

          <EditorBox>
            <InputTitle>내용</InputTitle>
            
              {add && content && <div><Editor initialHtml={content} setContent={setContent} /></div>}
              {!add && <div><Editor initialHtml={content} setContent={setContent} /></div>}
            
          </EditorBox>

          {/* <InputLinkBox>
            <TitleAndInput
              title="첨부파일"
              type="file"
              inputWidth="20rem"
              onChange={handleFile1Change}
            />
          </InputLinkBox>

          <InputLinkBox>
            <TitleAndInput
              title=""
              type="file"
              inputWidth="20rem"
              onChange={handleFile2Change}
            />
          </InputLinkBox> */}
        </AddBox>
      </div>

      <CommonFooter>
        <div></div>
        <AddBtns onClick={handleSubmit} />
      </CommonFooter>
      {isSpinner && <Spinner />}
    </FlexColBetweenBox>
  );
}

const AddBox = styled.div`
  
`;

const EditorBox = styled(InputLinkBox)`
  ${flexUnsetStart};
  gap: 0;

  h6 {
    margin-top: 0.75rem;
  }

  > div {
    width: calc(100% - 7.75rem);
    height: 400px;
    resize: none;
    overflow: auto;
  }
`